import { useEffect, useMemo, useSyncExternalStore } from 'react';
import {
    abonniereMeineRechte,
    holeMeineRechte,
    meineRechteStand,
    rechteSicht,
    type RechteSicht,
} from '../services/rechte/rechteService';

/**
 * Rechte der angemeldeten Person (Rollensystem, docs/rollensystem-plan.md
 * §6.1): `hat('preise.sehen')` usw.
 *
 * `systemrolle` ist `profiles.role` der angemeldeten Person. Solange nichts
 * geladen ist oder die Migration fehlt, gelten die Rechte dieser Systemrolle
 * (heutiges Verhalten); `admin`/`super_admin` haben immer alles.
 *
 * Alle Stellen teilen einen Speicher und eine Anfrage. Das Ergebnis bleibt
 * dasselbe Objekt, bis sich Stand oder Systemrolle ändern — `hat` taugt damit
 * als Abhängigkeit in `useMemo`/`useEffect`.
 */
export function useRechte(systemrolle: string | null | undefined): RechteSicht {
    const stand = useSyncExternalStore(abonniereMeineRechte, meineRechteStand, meineRechteStand);
    const rolle = systemrolle ?? null;
    // Ohne Systemrolle ist niemand (fertig) angemeldet — dann gibt es nichts
    // zu fragen; sobald das Profil da ist, lädt der Effekt nach.
    useEffect(() => { if (rolle) holeMeineRechte(); }, [rolle]);
    return useMemo(() => rechteSicht(stand, rolle), [stand, rolle]);
}
